module.exports = __webpack_public_path__ + "img/bank_transfer_select.53b5e07f.png";